// Short game sound effects callable from anywhere — React components and the
// PIXI interaction code alike (no hook needed). Respects the player's sound
// switch. Sounds: Kenney.nl packs (CC0), see public/game-assets/sounds/CREDITS.md.
import { Howl } from 'howler';
import useSoundStore from '../stores/useSoundStore';

const SFX = {
  /** A piece of furniture is picked up. */
  lift: { src: '/game-assets/sounds/furniture-lift.mp3', volume: 0.1 },
  /** A piece of furniture is set down. */
  drop: { src: '/game-assets/sounds/furniture-drop.mp3', volume: 0.12 },
  /** An item's menu opens. */
  menu: { src: '/game-assets/sounds/menu-open.mp3', volume: 0.08 },
  /** A tutorial step is done. */
  step: { src: '/game-assets/sounds/tutorial-step.mp3', volume: 0.12 },
  confetti: { src: '/game-assets/sounds/confetti.mp3', volume: 0.12 },
  victory: { src: '/game-assets/sounds/victory-fanfare.mp3', volume: 0.12 },
} as const;

export type SfxName = keyof typeof SFX;

const loaded = new Map<SfxName, Howl>();

function howl(name: SfxName): Howl {
  let h = loaded.get(name);
  if (!h) {
    h = new Howl({ src: [SFX[name].src], volume: SFX[name].volume, preload: true });
    loaded.set(name, h);
  }
  return h;
}

export function playSfx(name: SfxName): void {
  if (!useSoundStore.getState().soundsEnabled) return;
  try {
    howl(name).play();
  } catch {
    /* audio is optional */
  }
}

/** Load sounds ahead of their first use, so the first play is not late. */
export function preloadSfx(...names: SfxName[]): void {
  for (const name of names) howl(name);
}
